// extracted by mini-css-extract-plugin
export default {"imagesContainer":"PaymentMethodOption_imagesContainer__4iAm6","img":"PaymentMethodOption_img__OVv+J"};